export default __webpack_public_path__ + "files/6452d8183bfd6645b1e843517cf97ad9.png";